export enum Environment {
  LocalDevelopment = 'dev',

  // The values below are also defined in GCP.
  Staging = 'staging',
  Production = 'prod',
}
